export function sanitizeObjectNullishValues<T = Record<string, unknown>>(objectData: Nullable<T>): Nullable<T> {
  if (objectData === null || objectData === undefined) return null;
  return Object.fromEntries(Object.entries(objectData).filter(([_, value]) => value !== null)) as T;
}
